<template>
  <div
    :class="[
        'wg-row msg-container', 
        !printUser ? 'same-user' : '', 
        user.idWorldUser === msg.user ? 'personal' : '',
        sending ? 'temp' : ''
      ]"
  >
    <wg-modal v-if="edit" :width="windowWidth > 700 ? '700px' : '90%'" @closeModal="edit = false">
      <div class="com-anm22-app-text-l" slot="header">{{ $anm22.strLang(lang, 'Edit', 'Modifica') }}</div>
      <new-project-feed slot="body" :edit="edit" :projectId="projectId" :msgRef="msg"></new-project-feed>
    </wg-modal>
    <wg-modal v-if="openImportDialog" @closeModal="openImportDialog = false">
      <div
        class="com-anm22-app-text-l"
        slot="header"
      >{{ $anm22.strLang(lang, 'Import feed', 'Importa feed ') }}</div>
      <import-feed :msg="msg" :projectId="projectId" slot="body"></import-feed>
    </wg-modal>
    <wg-modal v-if="showDeleteDialog" @closeModal="showDeleteDialog = false;">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div
          class="com-anm22-app-text-xl"
        >{{ $anm22.strLang(lang, 'Delete feed?', 'Cancellare messaggio?') }}</div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="removeProjectFeed"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="showDeleteDialog = false;"
          />
        </div>
      </div>
    </wg-modal>
    <!-- <img v-if="printUser" :src="$anm22.getObjIcon(msgUser, 'userDefault')" /> -->
    <div
      v-if="printUser && msgUser"
      class="msg-img"
      style="min-width:30px;width:30px;height:30px;margin-right:5px;margin-top:2px;"
    >
      <world-object-icon :type="'user'" :obj="msgUser" :isImg="true"></world-object-icon>
    </div>
    <template v-if="msg.data.contentType !== 'HTML' &&  msg.data.type != 'reminder'">
      <img
        class="imgs-options"
        :style="{right: msg.data.type == 'meeting' || msg.data.type == 'textMsg' ? '4px' : '26px'}"
        :src="$anm22.icons.getWorldIcon('deleteBin')"
        @click="showDeleteDialog = true"
      />
      <img
        class="imgs-options"
        v-if="msg.data.type && msg.data.type != 'textMsg'  && msg.data.type != 'actionMsg'"
        :style="{right: msg.data.type == 'meeting' ? '26px' : '48px'}"
        :src="$anm22.icons.getWorldIcon('edit')"
        @click="edit = true"
      />
    </template>
    <img
      v-if="msg.data.type && msg.data.type != 'textMsg' && msg.data.type != 'reminder' &&  msg.data.type != 'meeting'"
      :src="$anm22.icons.getWorldIcon('shareFeed')"
      class="imgs-options"
      @click="openImportDialog = true"
      :title="$anm22.strLang(lang, 'Import feed', 'Importa feed')"
      style="right:4px;"
    />
    <div
      v-if="printUser && msgUser"
      class="wg-row msg-sender"
    >{{ user.idWorldUser === msg.user ? $anm22.strLang(lang, 'You', 'Tu') : msgUser.name }}</div>

    <!-- Compatibilita vecchi messaggi -->
    <img
      v-if="msgIcon"
      class="type-icon"
      :style="{backgroundColor: msgIcon.color,padding:(msg.data.type == 'call' || msg.data.type == 'msg') && (msg.data.category && msg.data.category != 'other'  && this.msg.data.category != 'sms') ? '0' : ''}"
      :src="msgIcon.icon"
    />
    <template v-if="!msg.data.type">
      <div class="wg-row">
        <div class="wg-row" style="flex-wrap:nowrap;">
          <div class="display-flex" style="margin-left:auto;flex-direction:column;">
            <div class="msg-time">{{ msg.ts | moment('HH:mm') }}</div>
          </div>
        </div>
        <template v-if="msg.data && msg.data.text">
          <iframe
            v-if="msg.data.contentType == 'HTML'"
            width="100%"
            class="iframe"
            frameborder="0"
            style="border:0"
            :srcdoc="msg.data.text"
            allowfullscreen
          ></iframe>
          <div v-else class="wg-row msg-body" v-html="$anm22.nl2br(msg.data.text)"></div>
        </template>
        <div v-else class="wg-row msg-body" v-html="$anm22.nl2br(msg.body)"></div>
      </div>
    </template>
    <!-- Se è impostato il tipo di messaggio renderizzo in base ai componenti dedicati -->
    <template v-else>
      <component
        :isBoard="true"
        :printUser="printUser"
        :msgUser="msgUser"
        :is="msgComponent"
        :msg="msg"
      ></component>
    </template>
    <div v-if="boardFeedAssoc.length > 0" class="wg-row" style="width:auto;">
      <div
        v-for="(assoc,index) in assocCustomers"
        :key="'assoc' + index"
        :title="assoc ? assoc.firstName + ' ' + assoc.lastName : ''"
      >
      <a :href="'https://contacts.anm22.it/contact/' + assoc.idContactsContact" target="_blank">
        <img
          style="margin:5px;"
          :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
          class="com-anm22-app-img-fixed-height-m"
        />
      </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FeedItemCall from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemCall.vue";
import FeedItemMsg from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemMsg.vue";
import FeedItemMeeting from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemMeeting.vue";
import FeedItemReminder from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemReminder.vue";
import FeedItemActionMsg from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemActionMsg.vue";
import FeedItemTextMsg from "../../../../../contacts/spa/src/components/feed-msgs/FeedItemTextMsg.vue";
import NewProjectFeed from "./NewProjectFeed.vue";
import ImportFeed from "./ImportFeed.vue";

export default {
  data() {
    return {
      openImportDialog: false,
      edit: false,
      showDeleteDialog: false
    };
  },
  props: {
    msg: Object,
    projectId: [Number, String],
    printUser: {
      type: Boolean,
      default: true
    },
    sending: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    msgComponent() {
      return "FeedItem" + this.$anm22.capitalizeFirst(this.msg.data.type);
    },
    msgUser() {
      return this.$store.getters["users/get"](this.msg.user);
    },
    assocCustomers() {
      return this.boardFeedAssoc.map(assoc =>
        this.$store.getters["contacts/get"](assoc.contact)
      ).filter(c => c);
    },
    boardFeedAssoc() {
      return this.$store.getters["feedBoardAssocs/getByBoardMessage"](
        this.msg.idWorldMessage
      );
    },
    msgIcon() {
      if (this.msg.data.type) {
        switch (this.msg.data.type) {
          case "textMsg":
            return {
              icon: this.$anm22.icons.getWorldIcon("textMsg"),
              color: "rgb(136, 237, 124)"
            };
            break;

         case "call":
          if(this.msg.data.category && this.msg.data.category != 'other' ) {
            return {
              icon: this.getImageByCategory(this.msg.data.category),
              color: ""
            }
          } else {
            return {
              icon: this.$anm22.icons.getWorldIcon("phoneWhite"),
              color: "orange"
            };
          }
          break;
        case "msg":
           if(this.msg.data.category && this.msg.data.category != 'other'  && this.msg.data.category != 'sms') {
            return {
              icon: this.getImageByCategory(this.msg.data.category),
              color: ""
            }
          } else {
          return {
            icon: this.$anm22.icons.getWorldIcon("chatWhite"),
            color: "#0aabf4"
          };
          }
          break;
          case "meeting":
            return {
              icon: this.$anm22.icons.getWorldIcon("placeWhite"),
              color: "red"
            };
            break;
          case "reminder":
            return {
              icon: this.$anm22.icons.getWorldIcon("reminderWhite"),
              color: "#777777"
            };
            break;
          case "actionMsg":
            return {
              icon: this.msg.data.icon,
              color: this.msg.data.color || "none"
            };
            break;
        }
      } else {
        return {
          icon: this.$anm22.icons.getWorldIcon("textMsg"),
          color: "rgb(136, 237, 124)"
        };
      }
    }
  },
  methods: {
    removeProjectFeed() {
      this.$http
        .post("project/deletemessage", {
          msg: this.msg
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("messages/delete", {
            vlf: this.$vlf("messages"),
            obj: response.data.msg
          }),
            this.$store.dispatch("feedBoardAssocs/deleteMultiple", {
              vlf: this.$vlf("feedBoardAssocs"),
              objs: response.data.assocs
            });
        })
        .catch(error => {
          //Eliminazione offline
          Promise.all([
            this.$store.dispatch("messages/delete", {
              vlf: this.$vlf("messages"),
              obj: this.msg
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "WorldMessage",
              _table: "messages",
              mode: 'delete',
              type: 'obj',
              obj: this.msg
            }),
            // this.$anm22.saveSyncTuple(this, "WorldMessage", "delete", this.msg)
          ]);
        })
        .finally(() => {
          this.$anm22.eventBus.$emit("wg-modal-close");
        });
    },
     getImageByCategory(category) {
      switch (category) {
         case "meet":
          return this.$anm22.icons.getWorldIcon("googleMeet");
          break;
        case "twitter":
          return this.$anm22.icons.getWorldIcon("twitter");
          break;
        case "slack":
          return this.$anm22.icons.getWorldIcon("slack");
          break;
        case "whatsapp":
          return this.$anm22.icons.getWorldIcon("whatsapp");
          break;
        case "zoom":
          return this.$anm22.icons.getWorldIcon("zoomLogo");
          break;
        case "fb":
          return this.$anm22.icons.getWorldIcon("facebook");
          break;
        case "email":
          return this.$anm22.icons.getWorldIcon("email");
          break;
        case "ig":
          return this.$anm22.icons.getWorldIcon("instagram");
          break;
        case "hang":
          return this.$anm22.icons.getWorldIcon("hangouts");
          break;
        case "skype":
          return this.$anm22.icons.getWorldIcon("skype");
          break;
        case "linkedin":
          return this.$anm22.icons.getWorldIcon("linkedin");
          break;
        case "inbox":
          return this.$anm22.icons.getWorldIcon("inbox");
          break;
        case "messenger":
          return this.$anm22.icons.getWorldIcon("messenger");
          break;
        case "discord":
          return this.$anm22.icons.getWorldIcon("discord");
          break;
        case "teams":
          return this.$anm22.icons.getWorldIcon("microsoftTeams");
          break;
      }
    }
  },
  components: {
    FeedItemCall,
    FeedItemMsg,
    FeedItemMeeting,
    FeedItemReminder,
    FeedItemActionMsg,
    FeedItemTextMsg,
    "new-project-feed": NewProjectFeed,
    "import-feed": ImportFeed
  }
};
</script>

<style lang="scss" scoped>
.iframe {
  height: 110px;
  min-height: 100px;
}
.imgs-options {
   cursor:pointer;
   position:absolute;
   top:1px;
   width:20px;
   height:20px;
   padding:2px;
}
.notop {
  margin-top: -9%;
}
.none {
  display: none;
}
.msgbottom {
  margin-top: 0px !important;
}
.msg-container {
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  border-radius: 8px;
  background-color: #fff;
  border: 1.5px solid #dbdbdb;
  width: auto;
  max-width: 90%;
  min-width: 100px;
  padding: 5px 20px 5px 5px;
  margin-top: 10px;
  &.temp {
    opacity: 0.4;
  }
  &.same-user {
    margin-top: 2px;
    & .msg-body {
      //  margin: 5px 0;
    }
  }
  & .msg-sender {
    flex-wrap: nowrap;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  & .msg-body {
    font-size: 13px;
    // margin-bottom: 5px;
    overflow: hidden;
  }
  & .msg-img {
    position: absolute;
    top: 15px;
    right: -15px;
    width: 30px;
    border-radius: 1000px;
  }
  & .msg-time {
    font-size: 12px;

    margin-left: auto;
  }
  .user-print-top {
    margin-top: 6%;
  }
  .type-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 50%;
    padding: 2px;
    object-fit: contain;
  }
  .same-user-print-top {
    margin-top: -1%;
  }
  // Messaggio inviato da me
  &.personal {
    padding: 5px 5px 5px 20px;
    border: none;
    background-color: #efefef;
    margin-left: auto;
    & .msg-img {
      position: absolute;
      top: 15px;
      left: -15px;
      width: 30px;
      border-radius: 1000px;
    }
  }
}
</style>
